const Divider = ({
  height = "2rem",
  color = "currentColor",
  margin = "0 0.8rem",
  width = "2px",
}) => {
  return (
    <span
      style={{
        display: "inline-block",
        width,
        height,
        backgroundColor: color,
        margin,
        verticalAlign: "middle",
      }}
    />
  );
};

export default Divider;
